import { USER_SEGMENT, TRAINER_TYPES } from "../constants";
export const getSegmentSlug = (segment: string) => {
  if (segment.includes('_')) return segment.split('_')[segment.split('_').length - 1];
  return segment;
};

/*USAGE: FOR replacing row values within segment with UI Friendly Slugs */
const getSegmentSlugArray = (segmentArray: string[]) => {
  return segmentArray.map((segment) => getSegmentSlug(segment));
};

/*USAGE: FOR Building UPDATE queries, compare currentValue with original DB Value*/
const getSegmentSlugHash = (segmentArray: string[]) => {
  return segmentArray.reduce((previous, current) => {
    return {
      ...[previous], [getSegmentSlug(current)]: current
    };
  }, {});
};



export const segmentSlugArray = getSegmentSlugArray(USER_SEGMENT);
export const segmentSlugHash = getSegmentSlugHash(USER_SEGMENT);

export const trainerSegmentArray = getSegmentSlugArray(TRAINER_TYPES);